/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Promos_Hidden_By_GatingInputs */



/**
* | output |
* | --- |
* | "{count} promo(s) not shown: restricted to other ranks or leagues." |
*
* @param {Promos_Hidden_By_GatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_hidden_by_gating = /** @type {((inputs: Promos_Hidden_By_GatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Hidden_By_GatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} promo(s) masquée(s) : restreinte(s) à d'autres rangs ou ligues.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} promo(s) oculta(s): restringida(s) a otros rangos o ligas.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} promo(s) oculta(s): restrita(s) a outras categorias ou ligas.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} promo nascosta/e: limitata/e ad altri rank o campionati.`)
	return /** @type {LocalizedString} */ (`${i?.count} promo(s) not shown: restricted to other ranks or leagues.`)
});